import { OnboardingInfo, ROnboarding } from '@dh/types';
import { setupOnboardingOrder } from './setupOnboardingOrder';

export function mapOnboardingInfo(remoteOnboarding: ROnboarding): OnboardingInfo {
    const { documentId, pageType, show_title_with_icon, title_de, description_de } =
        remoteOnboarding;
    const showIcon = show_title_with_icon ?? true;
    return {
        id: documentId,
        pageType,
        showIcon,
        title: {
            de: title_de
        },
        description: {
            de: description_de
        }
    };
}

export function mapOnboarding(onboarding: ROnboarding[] | null) {
    if (!onboarding) {
        return [];
    }
    const onboardingInfos = onboarding.map(mapOnboardingInfo);

    return setupOnboardingOrder(onboardingInfos);
}
